import React from 'react';
import styled from 'styled-components';
import { default as Button } from '../button';
import { theme } from 'fpay-ui';

const DetailedContainer = styled.div`
  width: 376px;
  height: 464px;
  background-color: #FFFFFF;
  border-radius: 8px;
  margin: 0;
  ${({ theme }) => theme.breakpoint('new_sm', 'new_lg')} {
    width: 343px;
    height: auto;
  }
  ${theme.breakpoint('sm', 'lg')} {
    margin-bottom: 24px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TitleTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #DEF1DA;  
  width: 100%;
  height: 53px;
  justify-content: flex-end;
  border-radius: 8px 8px 0 0;
  position: relative;
  margin-bottom: 19px;
`;

const Title = styled.b`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  color: #286A19;
  position: absolute;
  width: 100%;
  padding-right: 40px;
`;

const ContainerIcon = styled.div`
  width: 109px;
  height: 72px;
  position: relative;
  overflow: hidden;
  top: 10px;
  border-radius: 8px 8px 0 0;
`;

const CircleIcon = styled.div`
  position: absolute;
  width: 133px;
  height: 133px;
  top: -61px;
  left: -4px;
  background: #DEF1DA;
  border-radius: 0 0 50% 50%;
`;

const IconTitle = styled.div`
  position: absolute;
  top: 16px;
  right: 24px;
`;

const SubTitle = styled.h1`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  margin: 0;
  margin-top: 5px;
  color: #333333;
`;
const Amount = styled.b`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  display: flex;
  align-items: center;
  line-height: 28.13px;
  margin-top: 8px;
  color: #333333;
  & span {
    font-family: Roboto;
    font-size: 12px;
    font-weight: 700;
    line-height: 14.06px;
    text-align: center;
    color: #333333
  }
`;

const ContainerDetails = styled.div`
  height: 100%;
  border-top: ${(props) => props.haveSimulation ? 'none' : '1px solid #EBEBEB'};
  border-bottom: 1px solid #EBEBEB;
  margin-top: ${(props) => props.haveSimulation ? '0' : '24px'};
`;

const Disclaimer = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.06px;
  text-align: justify;
  color: #505050;
  margin: 24px 0;
  width: 290px;
`;

export default function ({
  title,
  subTitle,
  amount,
  details,
  icon,
  buttonText,
  buttonAction,
  buttonId,
  disclaimer,
  simulation
}) {
  const haveSimulation = !!simulation;
  return (
    <DetailedContainer>
      <TitleTextContainer>
        <ContainerIcon>
          <CircleIcon />
          <IconTitle>{icon}</IconTitle>
        </ContainerIcon>
        <Title>{title}</Title>
      </TitleTextContainer>
      <SubTitle>{subTitle}</SubTitle>
      <Amount>{amount}&nbsp;<span>(*)</span></Amount>
      {haveSimulation && (simulation)}
      <ContainerDetails haveSimulation={haveSimulation}>{details}</ContainerDetails>
      <Button text={buttonText} action={buttonAction} buttonId={buttonId} />
      <Disclaimer>{disclaimer}</Disclaimer>
    </DetailedContainer>
  );
}
